// extracted by mini-css-extract-plugin
module.exports = {"title":"setupPage_title__I5gAF","container":"setupPage_container__2RvO_"};